export const query_sos_byFascicolo = `
query getSOSByFascicolo($fascicoloId: Int!) {
  sos(where: {FascicoloId: {_eq: $fascicoloId}}, order_by: {Date: desc}) {
    Id
    Date
    Motivo
    Note
    ReceiptId
    ReportedByUser
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
    DateRicUif
    user {
      Name
      Surname
    }
  }
}`;
export const query_sos_byTenant_count = `
query countSOSByTenant($tenantId: String!, $aziendaId: Int!) {
  sos_aggregate(where: {
    fascicolo: {
      TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
      _or: [
        {_or: [{IsPrivate: {_eq: false}}]},
      ]
    }
  }) {
    aggregate {
      count(columns: Id)
    }
  }
}`;
export const query_sos_byTenant = `
query getSOSByTenant($tenantId: String!, $aziendaId: Int!, $userId: String!) {
  sos(where: {
    fascicolo: {
      TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
      _or: [
        {_or: [{IsPrivate: {_eq: false}}]},
        {_or: [
          {prestaziones: {prestazione_users: {UserId: {_eq: $userId}}}}
        ]}
      ]
    }
  }, order_by: {Date: desc}) {
    Id
    Date
    Motivo
    Note
    ReceiptId
    ReportedByUser
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
    DateRicUif
    fascicolo {
      Id
      Name
    }
    user {
      Name
      Surname
    }
    
  }
}`;